import { render, staticRenderFns } from "./MyBets.vue?vue&type=template&id=6bf76375"
import script from "./MyBets.vue?vue&type=script&lang=js"
export * from "./MyBets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports